// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"aC-z","smallCardRow":"bC-z","largeCardRow":"cC-z","productSearchRow":"dC-z","curatedRow":"eC-z"};